<div  [formGroup]="Group" class="mt-2 pb-3">
  <mat-checkbox color="primary" class="w-100" [formControlName]='Control.name' [(ngModel)]="stateValue" [value-object]="Control">
    <span class="w-100 text-wrap" id="label_{{Control.label}}" [translation]="TranslationEnum.TranslationForm">
      {{('label_'+ Control.label)|translate}}
    </span>
    <app-information [label]="Control.label" [notAffectOnOtherControl]='Control.notAffectToOtherControls' [fileInfoId]="Control.fileInfoId"></app-information>
  </mat-checkbox>
</div>
